<template>
  <div class="w-full md:w-80 mb-4">
    <IconField class="w-full">
      <InputIcon class="pi pi-search" />
      <InputText 
        :model-value="modelValue" 
        @update:model-value="$emit('update:modelValue', $event)"
        :placeholder="$t('user_manage.search_placeholder')" 
        class="w-full" 
      />
    </IconField>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue"
import InputText from 'primevue/inputtext'
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
console.log(t)

defineProps({
  modelValue: {
    type: String,
    default: ''
  }
})

defineEmits(['update:modelValue'])
</script>